module.exports = __webpack_public_path__ + "img/submit_btn.c23600a6.png";